export default "__VITE_ASSET__CGHHkSJl__"